// Operations of the guest payment checkout — the page an applicant lands on
// after submitting a paid form. It has no session at all: the bill id in the
// route and the form slug are the only credentials, and every resolver behind
// these names is self-scoping on the backend.
//
// PublicPaymentProviders and InterswitchCharges were missing from the client's
// auth guard, which errors an operation before it leaves the browser when no
// token is present. A real applicant (never logged in) therefore saw "Unable to
// load payment provider configuration" and had no way to pay; it only appeared
// to work for staff testing the page while signed in.
export const PUBLIC_CHECKOUT_OPERATIONS: ReadonlySet<string> = new Set([
  'PublicPaymentProviders',
  'InterswitchCharges',
  'InitiatePublicPayment',
  'ResolvePublicPayment',
  // A waiver code entered on the same page; the tracking code is the proof.
  'RedeemWaiverCodeAtCheckout',
]);

export const isPublicCheckoutOperation = (operationName?: string | null): boolean =>
  !!operationName && PUBLIC_CHECKOUT_OPERATIONS.has(operationName);
